module.exports = __webpack_public_path__ + "img/gggl1.171146f3.png";